import React, { useContext } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { Card, ProgramCardFooter } from './ProgramListingCard';
import { ProgramCategory } from '@gql/generated';
import LanguageContext from '@lib/contexts/languageContext';
import useFlags from '@lib/hooks/useFlags';

export const Anchor = styled(Link)`
  display: flex;
  color: inherit;
  text-decoration: none;

  &:nth-of-type(n + 2) {
    display: none;
  }

  & ~ .VideoGenresList--VideoCard:nth-of-type(12n):last-of-type {
    display: none;
  }
`;

const Text = styled.span<{ fontSize?: number; fontWeight?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: ${({ fontSize }) => fontSize || 18}px;
  font-weight: ${({ fontWeight }) => fontWeight || 'normal'};
  margin: 0 0 10px;
`;

const Body = styled.div<{ appearance?: ProgramCategory }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  text-align: center;
  /* padding: 15% 10px; */
`;

const Image = styled.img`
  width: 100%;
  min-height: 100%;
  object-fit: cover;
`;

const Footer = styled(ProgramCardFooter)`
  justify-content: center;
  color: #fff;
  border-color: rgba(6, 129, 184, 1);
  background-color: ${({ theme }) => theme.colors.secondary.blue};

  svg {
    margin-left: 10px;

    path {
      fill: white;
    }
  }

  p {
    font-size: 14px;
    font-weight: 600;

    svg {
      display: none;
    }
  }
`;

const OfferCard = ({ className = '' }) => {
  const [flags] = useFlags();
  // const [currentUser] = useContext(UserContext);
  const locale = useContext(LanguageContext);

  if (
    !flags.yearly_campaign_banners
    //   !['se', 'no'].includes(lang) ||
    //   // user not loaded yet
    //   currentUser === undefined ||
    //   // user doesnt have trial premium
    //   (currentUser?.subscription?.status === SubscriptionStatus['Active'] &&
    //     ['monthly', 'quarterly', 'yearly'].includes(
    //       currentUser?.subscription?.currentSubscriptionPlan?.planType
    //     )) ||
    //   // has wellness
    //   currentUser?.hasWellness
  ) {
    return null;
  }

  const lang = ['en', 'fi'].includes(locale) ? 'en' : 'se';

  const href = `/${lang}/yearly?ref=library_square_banner`;
  return (
    <Anchor className={className} href={href}>
      <Card data-testid="OfferCard">
        <Body>
          {/* <Text fontSize={26} fontWeight={700}>
              Tidsbegränsat erbjudande
            </Text>
            <Text fontSize={16}>Spara upp till 669 SEK</Text>
            <Text style={{ flex: 1 }} fontSize={60} fontWeight={700}>
              1599 SEK
            </Text>
            <Text fontSize={24}>Årsprenumeration</Text> */}
          <Image
            src={
              lang === 'en'
                ? '/static/yearly/ENg_Web_1_1.jpg'
                : '/static/yearly/Web_1_1.jpg'
            }
          />
        </Body>
        {/* <Footer programCategory={ProgramCategory['Programs']}>
            Uppgradera idag
          </Footer> */}
      </Card>
    </Anchor>
  );
};

export default OfferCard;
